import CallLogWithDurationResourceModel from '../../generated/types/model/resource/CallLogWithDurationResourceModel';

export default class CallLogWithDurationResourceViewModel extends CallLogWithDurationResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
